import React from "react";
import { Link } from "react-router-dom";
import services from "../../../data/services.json";

function ServiceList() {
  const scrollTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  return (
    <>
      <div className="sidebar-widget">
        <h4>Services</h4>
        <ul className="service-list">
          {services.map((service) => (
            <li key={service.id}>
              <Link to={`${process.env.PUBLIC_URL}/service-details/${service.slug}`} onClick={scrollTop}>
                <i>
                  <img
                    src={
                      process.env.PUBLIC_URL +
                      "/images/icons/dash-circle-icon.svg"
                    }
                    alt={service.title}
                  />
                </i>
                {service.title}
              </Link>
            </li>
          ))}
        </ul>
      </div>
    </>
  );
}

export default ServiceList;
